interface SpaceHrProps {
  my?: string | number;
  className?: string;
}
const SpaceHr = ({ my, className }: SpaceHrProps) => {
  return (
    <hr className={className} style={{ marginTop: my, marginBottom: my }} />
  );
};

export default SpaceHr;
